import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getPartnerDetails} from '../../selector';
import {TRANSLATION_CONSTANTS} from "../../app-consts/translations";
import {useLocale} from "../../contexts/LocaleContext";

type PartnerBrandProps = {
  isRescueTrackerStandalone?: boolean;
}

const PartnerBrand = ({isRescueTrackerStandalone}: PartnerBrandProps) => {
  const partnerDetails = useSelector(getPartnerDetails);
  const getTranslatedText = useLocale()
  const {image, brand, displayCode, headerColor, fontColor, name} = partnerDetails;
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    const multipleLogos = image?.split(',');
    if (multipleLogos?.length > 1) {
      let newLogos = []
      multipleLogos.forEach((logo: string, i: number) => {
        newLogos.push(<img key={`${i}`} src={`/images/${logo}`} alt={`${brand}`}/>)
        setLogos(newLogos)
      })
    } else if (image) {
      setLogos([<img key="1" src={`/images/${image}`} alt={`${brand}`}/>])
    } else if (isRescueTrackerStandalone){
      const svgPath = `/images/rt-partner-logos/${displayCode}/header.svg`;
      const pngPath = `/images/rt-partner-logos/${displayCode}/header.png`;
      setLogos([<img key="rt-1" className='rescue-tracker-partner-logo' src={pngPath} alt={`${name}`} onError={(e) => { e.currentTarget.src = svgPath; e.currentTarget.className = ''; }} />])
    }
  },[partnerDetails]);

  return (
    <div>
      <div style={{backgroundColor: `${headerColor}`}} className={`brandingMast ${displayCode}`}>
        {partnerDetails.isHeaderBrandingEnabled ? <p style={{color: `${fontColor}`}}>{getTranslatedText(TRANSLATION_CONSTANTS.PROVIDED_BY)}</p> : null}
        {logos}
      </div>
    </div>
  )
};

export default PartnerBrand